import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCode, faCodeCommit, faCogs, faUsers } from "@fortawesome/free-solid-svg-icons";
import { withTranslation } from "lib/i18n";

const iconMap = {
  clientFocused: faUsers,
  expertise: faCode,
  efficientProcess: faCogs,
  qualityInnovation: faCodeCommit,
};

class WhyWorkWithUs extends Component {
  render() {
    const { t } = this.props.i18n;
    const items = Array.isArray(t("why.items")) ? t("why.items") : [];
    return (
      <>
        <section className="why-work-with-us portfolio">
          <div className="container text-center">
            <div className="row align-items-center">
              <div className="col-12">
                <div className="portfolio-title text-white mb-5 mt-4">
                  <h2 className="title-font">{t("why.heading")}</h2>
                  <p className="mt-4 mb-4 title-font-2">
                    {t("why.intro")}
                  </p>
                </div>
              </div>

              </div>

              <div className="services">
                <div className="container text-white">
                <div className="row">
                {items.map((work) => (
                // show portfoilo boxes by mapping the array of images
                <div className="col-lg-6 col-md-6 col-sm-12" key={work.id}>
                  <div className="service-boxes-vertical service-card">
                  <div className="service-icon">
                    <FontAwesomeIcon icon={iconMap[work.id]} aria-hidden="true" />
                  </div>
                  <div className="service-info-title">
                    <h3 className="service-name title-font-2">
                      {work.title}
                    </h3>
                  </div>
                  <div className="service-info">
                    <p className="service-description title-font-2">
                      {work.description}
                    </p>
                  </div>
                  <div className="card-header-row">
                    <span className="card-tag">{t("labels.principle")}</span>
                    <span className="card-dot" aria-hidden="true"></span>
                  </div>
                </div>
                </div>
              ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    items: state.works,
  };
};

export default connect(mapStateToProps)(withTranslation(WhyWorkWithUs));
